import CashProceeds from './views/cash_proceeds.c';
export default CashProceeds;
